var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return [_c('div',{staticStyle:{"height":"120px"},attrs:{"data-cy":"loader"}},[_c('LoaderComponent')],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }